import { render } from "./radios-mobile.vue?vue&type=template&id=f666d76c&ts=true"
import script from "./radios-mobile.vue?vue&type=script&lang=ts"
export * from "./radios-mobile.vue?vue&type=script&lang=ts"

import "./radios-mobile.vue?vue&type=style&index=0&id=f666d76c&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__